var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2331_62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 0H5C3.6744 0.00158786 2.40356 0.528882 1.46622 1.46622C0.528882 2.40356 0.00158786 3.6744 0 5L0 19C0.00158786 20.3256 0.528882 21.5964 1.46622 22.5338C2.40356 23.4711 3.6744 23.9984 5 24H19C20.3256 23.9984 21.5964 23.4711 22.5338 22.5338C23.4711 21.5964 23.9984 20.3256 24 19V5C23.9984 3.6744 23.4711 2.40356 22.5338 1.46622C21.5964 0.528882 20.3256 0.00158786 19 0ZM22 19C22 19.7956 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7956 22 19 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7956 2 19V5C2 4.20435 2.31607 3.44129 2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H19C19.7956 2 20.5587 2.31607 21.1213 2.87868C21.6839 3.44129 22 4.20435 22 5V19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33306 15.9191L5.41406 12.0001C5.22653 11.8126 4.97223 11.7073 4.70706 11.7073C4.4419 11.7073 4.18759 11.8126 4.00006 12.0001C3.81259 12.1876 3.70728 12.4419 3.70728 12.7071C3.70728 12.9722 3.81259 13.2265 4.00006 13.4141L7.91906 17.3331C8.10479 17.5189 8.3253 17.6662 8.56801 17.7668C8.81071 17.8674 9.07085 17.9191 9.33356 17.9191C9.59627 17.9191 9.85641 17.8674 10.0991 17.7668C10.3418 17.6662 10.5623 17.5189 10.7481 17.3331L20.0001 8.08105C20.1875 7.89353 20.2928 7.63922 20.2928 7.37405C20.2928 7.10889 20.1875 6.85458 20.0001 6.66705C19.8125 6.47958 19.5582 6.37427 19.2931 6.37427C19.0279 6.37427 18.7736 6.47958 18.5861 6.66705L9.33306 15.9191Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2331_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.08b75a594f2c552eb5484ef2662a43f5.svg";
export { ForwardRef as ReactComponent };